import React from 'react'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../common/integrations'
import { PostConnectStepFrame } from '../PostConnectStepFrame'
import { OnboardingStepFinished } from '../../Onboarding/OnboardingStepFinished/OnboardingStepFinished'
import { POST_CONNECT_COPIES } from '../../copies/onboardingCopies'

export interface CalendarSuccessStepProps {
  serviceId: IntegrationServiceId
  onContinue: () => void
  onBack?: () => void
}

export const CalendarSuccessStep: React.FC<CalendarSuccessStepProps> = ({ serviceId, onContinue, onBack }) => {
  const displayName = getIntegrationDisplayName(serviceId)
  const eventFilterPath = '/account/profile-settings/meeting-assistant'

  return (
    <PostConnectStepFrame onAdvance={onContinue} onBack={onBack} nextLabel='Done'>
      <OnboardingStepFinished
        title={`${displayName} set up successfully`}
        bullets={POST_CONNECT_COPIES['calendar-success'].bullets}
        links={[{ label: 'Set up custom Event filters', to: eventFilterPath }]}
      />
    </PostConnectStepFrame>
  )
}
